import React, { useState, useRef } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { Link } from "react-router-dom";
import "./jobForm.css";
import axios from "axios";
import Spinner from "../misc/spinner";

const JobForm = () => {
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [invalidEmail, setInvalidEmail] = useState("Email is required");
  const [selectedFile, setSelectedFile] = useState("");
  // const [additionalFile, setAdditionalFile] = useState("");

  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setEmailError] = useState(false);
  const [isMessageError, setMessageError] = useState(false);
  const [isPhoneError, setPhoneError] = useState(false);
  const [isFileError, setFileError] = useState(false);
  const [isTitleError, setIsTitleError] = useState(false);

  const [spinner, setSpinner] = useState(false);

  const validateEmail = (email) => {
    const re =
      // eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const fileInput = useRef(null);
  // const fileAddInput = useRef(null);
  const maxfilesize = 1024 * 1024;
  const handleFileInput = (e) => {
    setSelectedFile(e.target.files[0]);
    console.log(e.target.files[0]);
    setFileError(false);
    if (e.target.files[0].size > maxfilesize) {
      console.log("File size exceeds 1 MiB");
    }
  };

  // const handleAddFileInput = (e) => {
  //   setFileError(false);
  //   setAdditionalFile(e.target.files);
  //   console.log(e.target.files);
  // };

  const saveJobForm = (e) => {
    e.preventDefault();

    if (name === "") {
      setIsFirstNameError(true);
    }

    if (message === "") {
      setMessageError(true);
    }

    if (email === "") {
      setEmailError(true);
      setInvalidEmail("Email required");
    } else {
      if (!validateEmail(email)) {
        setEmailError(true);
        setInvalidEmail("Invalid Email");
        return false;
      }
    }
    if (title === "") {
      setIsTitleError(true);
    }

    if (selectedFile === "") {
      setFileError(true);
    }

    if (
      name === "" ||
      message === "" ||
      email === "" ||
      title === "" ||
      selectedFile === ""
    ) {
      return false;
    }

    const bodyData = new FormData();
    bodyData.append("title", title);
    bodyData.append("name", name);
    bodyData.append("message", message);
    bodyData.append("email", email);
    bodyData.append("formfile", selectedFile);
    bodyData.append("formFiles", []);
    setSpinner(true);
    axios({
      method: "post",
      url: "https://2mnordic-api.azurewebsites.net/contact",
      data: bodyData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    })
      .then((response) => {
        setSpinner(false);
        setName("");
        setMessage("");
        setSelectedFile("");
        setEmail("");
        setTitle("");
        console.log(response);
      })
      .catch((error) => {
        setSpinner(false);
        console.log(error);
      });
  };

  return (
    <>
      <Header />
      <form>
        <section className="md:mt-16 md:mt-8 mt-14 bg-Gray-50">
          <div className="mid-container">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="pt-20">
                <div className="w-4/5 mx-auto">
                  <div className="md:w-4/5 w-full job-form-header relative py-6 mx-auto">
                    <h1 className="md:text-5xl text-3xl leading-tight font-avenirHeavy text-Gray-900 mobile-text">
                      The right environment{" "}
                      <span className="md:block inline-block">
                        for innovation to happen.
                      </span>
                    </h1>
                    <p className="pt-12 text-Gray-600 font-opensans md:text-base text-sm">
                      We believe great work comes from a great work environment
                      and a strong set of values. Find out what’s important to
                      us and see if we’re a good fit for you.
                    </p>
                    <p className="pt-4 text-Gray-600 font-opensans md:text-base text-sm">
                      Tell us a little more about yourself and why you are
                      looking for a job at 2Mnordic.
                    </p>
                    <div className="my-12">
                      <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                        Your message
                      </label>
                      <textarea
                        type="text"
                        name="message"
                        value={message}
                        onChange={(e) => {
                          setMessage(e.target.value);
                          setMessageError(false);
                        }}
                        className={`input-field text-sm resize-none placeholder-lightGray-100 ${
                          isMessageError ? "is-invalid" : null
                        }`}
                        placeholder="Your message goes here"
                        rows="3"
                      ></textarea>
                      {isMessageError ? (
                        <span className="text-red-900 text-xs">
                          Message required
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-10">
          <div className="mid-container">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="w-4/5 mx-auto">
                <div className="md:w-4/5 w-full relative py-6 mx-auto">
                  <h4 className="font-avenirHeavy text-Gray-900 text-2xl md:pb-10 pb-5">
                    Personal Information
                  </h4>
                  <div className="grid md:grid-cols-2 grid-cols-2 gap-8">
                    <div className="">
                      <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                        Title
                      </label>
                      <input
                        type="text"
                        name="title"
                        value={title}
                        onChange={(e) => {
                          setTitle(e.target.value);
                          setIsTitleError(false);
                        }}
                        className={`input-field text-sm ${
                          isTitleError ? "is-invalid" : null
                        }`}
                      />
                      {isTitleError ? (
                        <span className="text-red-900 text-xs">
                          Name required
                        </span>
                      ) : null}
                    </div>
                    <div className="">
                      <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                        Your name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          setIsFirstNameError(false);
                        }}
                        className={`input-field text-sm ${
                          isFirstNameError ? "is-invalid" : null
                        }`}
                      />
                      {isFirstNameError ? (
                        <span className="text-red-900 text-xs">
                          Name required
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 grid-cols-1 gap-8 my-10">
                    <div className="">
                      <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                        Your email
                      </label>
                      <input
                        type="text"
                        name="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setEmailError(false);
                        }}
                        className={`input-field text-sm ${
                          isEmailError ? "is-invalid" : null
                        }`}
                      />
                      {isEmailError ? (
                        <span className="text-red-900 text-xs">
                          {invalidEmail}
                        </span>
                      ) : null}
                    </div>
                    <div className="">
                      <label className="text-xs font-opensans text-Gray-400 pb-3 block">
                        Phone
                      </label>
                      <input
                        type="text"
                        name="phone"
                        value={phone}
                        maxLength="10"
                        onChange={(e) => {
                          setPhone(e.target.value.replace(/\D/g, ""));
                          setPhoneError(false);
                        }}
                        className={`input-field text-sm ${
                          isPhoneError ? "is-invalid" : null
                        }`}
                      />
                      {isPhoneError ? (
                        <span className="text-red-900 text-xs">
                          Phone required
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="grid md:grid-cols-1 grid-cols-1 gap-8 my-10">
                    <div className="relative">
                      <label className="text-xs font-opensans text-Gray-400 pb-0 block">
                        Upload your CV
                      </label>
                      <input
                        type="file"
                        onChange={handleFileInput}
                        ref={fileInput}
                        accept=".doc,.docx,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        className={`input-field absolute top-0 left-0 opacity-0 z-1 w-0 h-0`}
                      />
                      <div
                        className="input-field block px-3 flex flex-row justify-between relative z-50 opacity-100 items-center"
                        onClick={(e) =>
                          fileInput.current && fileInput.current.click()
                        }
                      >
                        <span className="text-13 font-avenirHeavy ">
                          {selectedFile.name}
                        </span>
                        <span className="bg-blue-500 rounded text-white text-sm py-2 px-5 font-normal font-avenirHeavy inline-block my-1">
                          Browse
                        </span>
                      </div>
                      {isFileError ? (
                        <span className="text-red-900 text-xs">
                          File required
                        </span>
                      ) : null}
                      <span className="text-xs font-avenirBook text-blue-800 block pt-2">
                        Only .pdf, .doc and .docx are allowed, File size must
                        under 1MB
                      </span>
                    </div>
                  </div>
                  {/* <div className="grid md:grid-cols-1 grid-cols-1 gap-8 my-10">
                    <div className="relative">
                      <label className="text-xs font-opensans text-Gray-400 pb-0 block">
                        Additional files
                      </label>
                      <input
                        type="file"
                        onChange={handleAddFileInput}
                        ref={fileAddInput}
                        multiple
                        accept=".doc,.docx,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        className={`input-field absolute top-0 left-0 opacity-0 z-1 w-0 h-0`}
                      />
                      <div
                        className="input-field block px-3 flex flex-row justify-between relative z-50 opacity-100 items-center"
                        onClick={(e) =>
                          fileAddInput.current && fileAddInput.current.click()
                        }
                      >
                        <span className="text-13 font-avenirHeavy ">
                          {additionalFile.name}
                        </span>
                        <span className="bg-blue-500 rounded text-white text-sm py-2 px-5 font-normal font-avenirHeavy inline-block my-1">
                          Browse
                        </span>
                      </div>
                      <span className="text-xs font-avenirBook text-blue-800">
                        Only .pdf, .doc and .docx are allowed, File size must
                        under 1MB
                      </span>
                    </div>
                  </div> */}
                  <div className="flex flex-row justify-end mt-4 button-row">
                    <button
                      className={`brand-primary-sm-btn`}
                      type="submit"
                      onClick={saveJobForm}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="text-xs py-10 text-center font-opensans text-Gray-600 md:px-0 px-6">
            I have read the{" "}
            <Link to="/privacy-policies" className="underline">
              Privacy Policy
            </Link>{" "}
            and confirm that 2Mnordic store my personal details to be able to
            process my job application.
          </p>
        </section>
      </form>
      <Footer />
      {spinner ? (
        <div className="fixed top-0 left-0 bottom-0 right-0 bg-white bg-opacity-50 z-50">
          <div className="flex flex-col items-center justify-center h-full">
            <Spinner />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default JobForm;
